import { Map } from 'immutable';

import Campaign from 'entities/campaign/model';

import { ADD, ADD_MULTIPLE, UPDATE } from './constants';

export const addAction = (campaign: Campaign): { campaign: Campaign; type: typeof ADD } => ({
  type: ADD,
  campaign,
});

export const addMultipleAction = (
  campaigns: Map<string, Campaign>
): { campaigns: Map<string, Campaign>; type: typeof ADD_MULTIPLE } => ({
  type: ADD_MULTIPLE,
  campaigns,
});

export const updateAction = (campaign: Campaign): { campaign: Campaign; type: typeof UPDATE } => ({
  type: UPDATE,
  campaign,
});
